import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Chart} from '@components/chart'
import {cn} from '@containers/html-utils'
import {useStatsPageStore} from './stats-page-store'

export const StatsPageChart = observer(() => {
  const [state, store] = useStatsPageStore()

  return (
    <div className="stp-chart">
      <div
        className={cn('stp-chart-legend', state.table.chartHours && 'hours')}
      >
        <div className="stp-chart-legend-item">
          <span className="stp-chat-legend-num">{state.table.openTot}</span>
          {!state.table.chartHours && (
            <span className="stp-chat-legend-text">
              {Lang.msg.tsTasksRemain}
            </span>
          )}

          {!!state.table.chartHours && (
            <span className="stp-chat-legend-text">
              {Lang.msg.tsHoursRemain}
            </span>
          )}
        </div>
        <div className="stp-chart-legend-item">
          <span className="stp-chat-legend-num">{state.table.closedTot}</span>
          {!state.table.chartHours && (
            <span className="stp-chat-legend-text">
              {Lang.msg.tsTasksClosed}
            </span>
          )}
          {!!state.table.chartHours && (
            <span className="stp-chat-legend-text">
              {Lang.msg.tsHoursClosed}
            </span>
          )}
        </div>
      </div>

      <div className="stp-chart-cnt">
        <Chart
          data={state.table.chartData}
          key2={Lang.msg.tsKeyOpen}
          key1={Lang.msg.tsKeyClosed}
          alternativeColors={state.table.chartHours}
        />
      </div>
      <div className="stp-chart-side">
        <div
          className={cn(
            'stp-chart-hours-option',
            !state.table.chartHours && 'active'
          )}
          onClick={() => store.updateChartHours(false)}
        >
          {Lang.msg.tsTaskCount}
        </div>
        <div
          className={cn(
            'stp-chart-hours-option',
            state.table.chartHours && 'active'
          )}
          onClick={() => store.updateChartHours(true)}
        >
          {Lang.msg.tsTaskHours}
        </div>
      </div>
    </div>
  )
})
